const PRODUCTION_HOST = "analyze.nyafaz.com";
const PRODUCTION_API_PATH = "/naturals-portal-api";

const resolveApiBase = () => {
  if (typeof window !== "undefined") {
    const host = String(window.location.hostname || "").toLowerCase();
    if (host === PRODUCTION_HOST) {
      return PRODUCTION_API_PATH;
    }
  }

  const configured = process.env.REACT_APP_NATURALS_PORTAL_API_URL?.replace(/\/$/, "");
  if (configured && typeof window !== "undefined") {
    const host = window.location.hostname;
    const pageIsLocal = host === "localhost" || host === "127.0.0.1";
    const configuredIsLocal =
      configured.includes("localhost") || configured.includes("127.0.0.1");
    if (!pageIsLocal && configuredIsLocal) {
      return PRODUCTION_API_PATH;
    }
    return configured;
  }
  if (configured) return configured;
  if (typeof window !== "undefined") {
    const host = window.location.hostname;
    if (host === "localhost" || host === "127.0.0.1") {
      return "http://localhost:5125";
    }
  }
  return PRODUCTION_API_PATH;
};

export function getApiBase() {
  return resolveApiBase();
}

export function portalApiUrl(path) {
  const base = getApiBase().replace(/\/$/, "");
  const suffix = path.startsWith("/") ? path : `/${path}`;
  return `${base}${suffix}`;
}

export const API_BASE = getApiBase();
